import request from "./config/http.js";

let dev = "/tsg-admin"; //公共请求头

// 首页查询四类（稿件审核，稿件分配，录用后，业务审核）待处理操作的数量
const apis = {
    // /sys/articleHome/queryArticleAuditList 稿件审核列表查询
    queryArticleAuditList(data) {
        return request({
          url: dev + "/sys/articleHome/queryArticleAuditList",
          method: "get",
          params: data,
        }).then((result) => {
          return Promise.resolve(result.data);
        });
      },
    
    // /sys/articleHome/queryArticleAllotList 稿件分配列表查询
    queryArticleAllotList(data) {
        return request({
          url: dev + "/sys/articleHome/queryArticleAllotList",
          method: "get",
          params: data,
        }).then((result) => {
          return Promise.resolve(result.data);
        });
      },
    // /sys/articleHome/queryArticleAfterEmploymentList 稿件录用后列表查询
    queryArticleAfterEmploymentList(data) {
        return request({
          url: dev + "/sys/articleHome/queryArticleAfterEmploymentList",
          method: "get",
          params: data,
        }).then((result) => {
          return Promise.resolve(result.data);
        });
      },
 
    // /sys/articleHome/queryArticleBusinessAuditList 稿件业务审核列表查询
    queryArticleBusinessAuditList(data) {
        return request({
          url: dev + "/sys/articleHome/queryArticleBusinessAuditList",
          method: "get",
          params: data,
        }).then((result) => {
          return Promise.resolve(result.data);
        });
      },

};

export default apis; 


// WEBPACK FOOTER //
// ./src/core/api/shouye.serve.js